import React from 'react';
import { Box, Flex } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { Skeleton } from '@shared/components/Skeleton';

export const HotelTilePricingSkeleton: React.FC = () => {
  return (
    <Flex
      flexDirection="column"
      gap={3}
      borderTop="1px solid"
      borderTopColor="mono3"
      paddingTop={4}
    >
      {/* Top Row Skeleton */}
      <Flex
        justifyContent="space-between"
        alignItems="center"
      >
        <Skeleton
          placeholder={
            <Box
              width={pxToRem(100)}
              height={pxToRem(24)}
              backgroundColor="mono3"
            >
              &nbsp;
            </Box>
          }
        />
        <Skeleton
          placeholder={
            <Box
              width={pxToRem(50)}
              height={pxToRem(24)}
              backgroundColor="mono3"
            >
              &nbsp;
            </Box>
          }
        />
      </Flex>
      {/* Bottom Row Skeleton */}
      <Flex
        justifyContent="space-between"
        alignItems="flex-start"
      >
        <Skeleton
          placeholder={
            <Box
              width={pxToRem(80)}
              height={pxToRem(16)}
              backgroundColor="mono3"
            >
              &nbsp;
            </Box>
          }
        />
        <Flex
          gap={1}
          alignItems="baseline"
        >
          <Skeleton
            placeholder={
              <Box
                width={pxToRem(40)}
                height={pxToRem(24)}
                backgroundColor="mono3"
              >
                &nbsp;
              </Box>
            }
          />
          <Skeleton
            placeholder={
              <Box
                width={pxToRem(40)}
                height={pxToRem(24)}
                backgroundColor="mono3"
              >
                &nbsp;
              </Box>
            }
          />
        </Flex>
      </Flex>
    </Flex>
  );
};
